import { useAppSelector } from 'store/hooks';

export const useIsTrialCanceled = () => {
  const subscriptionState = useAppSelector(state => state.customer.subscription)?.status;

  return subscriptionState === 'on trial grace';
};
